
import React from 'react';
import { Compass, PawPrint } from 'lucide-react';
import Hero from '@/components/Hero';
import Features from '@/components/Features';
import PhotoGallery from '@/components/PhotoGallery';
import BookInfo from '@/components/BookInfo';
import PressLogos from '@/components/PressLogos';
import GiftCardCTA from '@/components/GiftCardCTA';
import TourUpdates from '@/components/TourUpdates';
import IntroSection from '@/components/home/IntroSection';
import MailchimpLoader from '@/components/home/MailchimpLoader';
import FeaturedTestimonial from '@/components/home/FeaturedTestimonial';
import SeasonalBanner from '@/components/home/SeasonalBanner';
import NewsletterSection from '@/components/home/NewsletterSection';
import EmotionalBenefits from '@/components/home/EmotionalBenefits';
import FinalCTA from '@/components/home/FinalCTA';
import HomeSEO from '@/components/home/HomeSEO';
import { galleryImages, pressLogos, tourFeatures, seasonalContent } from '@/components/home/HomeData';

const Index = () => {
  return (
    <div className="min-h-screen">
      {/* SEO and Structured Data */}
      <HomeSEO />
      
      {/* Mailchimp script loader */}
      <MailchimpLoader />
      
      {/* Hero Section - Updated headline and subheadline */}
      <Hero 
        title="Time-Travel Through NYC's Feline History: Where Cats Made Their Mark!" 
        subtitle="The Only Cat-Themed Historical Walking Tours in NYC - Tales from Whiskers Past"
        buttonText="Book Your Tour – Only $40!"
        buttonLink="/booking"
        secondaryButtonText="Learn More About Our Tours"
        secondaryButtonLink="/tours"
        secondaryButtonIcon={<Compass className="mr-2" aria-hidden="true" />}
        backgroundImage="/lovable-uploads/f0cb5bcd-d58d-44ab-9619-011f839bec4f.png"
        height="full"
        imageStyle="natural"
        imagePosition="bottom"
        backgroundAlt="Historic New York cat walking tour"
        contentPosition="center"
        className="relative bg-cover bg-center"
        showTrustBadges={false}
        showUrgencyMessage={false}
        overlay={false}
      />
      
      {/* Enhanced Featured In Section - Press Logos */}
      <PressLogos logos={pressLogos} className="text-center py-8 bg-[#F5F5DC]" />
      
      {/* Featured Testimonial Section */}
      <FeaturedTestimonial />
      
      {/* Seasonal Banner */}
      <SeasonalBanner 
        heading={seasonalContent.heading}
        subheading={seasonalContent.subheading}
      />
      
      {/* Enhanced Introduction Section - Now using the IntroSection component */}
      <IntroSection />
      
      {/* Custom Mailchimp Newsletter Section */}
      <NewsletterSection />
      
      {/* Gift Card CTA */}
      <GiftCardCTA />
      
      {/* Enhanced Highlights of Our Tours Section with Features */}
      <Features
        title="Why Our NYC Cat History Tours Are Unique"
        subtitle="Embark on a journey that blends history with heart, and see NYC in a way you've never seen before."
        features={tourFeatures.map(feature => ({
          ...feature,
          icon: feature.icon || <PawPrint className="text-[#C46829]" aria-hidden="true" />
        }))}
        className="bg-[#FDF6ED]"
        columns={2}
      />
      
      {/* Emotional Benefits Section */}
      <EmotionalBenefits />
      
      {/* Tour Updates Section */}
      <TourUpdates />
      
      {/* Enhanced Book Section */}
      <BookInfo
        title="The Cat Men of Gotham: Tales of Feline Friendships in Old New York"
        description="The nineteenth century was a rough time to be a stray cat in New York City. The city's human residents dealt with feline overpopulation by gassing unwanted cats or tossing them in rivers. But a few lucky strays were found by a diverse array of men including firemen, cops, athletes, and politicians—who rescued them from the streets and welcomed them into their homes and hearts.\n\nEach book is signed by the author Peggy Gavan."
        image="/lovable-uploads/32eb94c5-1e72-4a43-971f-b5baa4e11564.png"
        ctaText="Email us to order"
        ctaLink="mailto:catsabouttowntour@gmail.com"
      />
      
      {/* Enhanced Gallery Section */}
      <PhotoGallery
        images={galleryImages.map(img => ({
          ...img,
          alt: img.alt || "NYC cat history walking tour in Brooklyn Heights"
        }))}
        title="See it for yourself"
        subtitle="Browse our gallery of tour experiences and join us on our next adventure"
        columns={3}
      />
      
      {/* Final CTA */}
      <FinalCTA />
    </div>
  );
};

export default Index;
